import { ExternalLink } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Card, CardContent } from '@/modules/shared/components/ui/card'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/modules/shared/components/ui/table'
import { cn } from '@/modules/shared/lib/utils'
import { formatDateBy } from '@/modules/shared/utils/dateFormatter'
import { numberFormatter } from '@/modules/shared/utils/formatter'

import type { TClientReport } from '../types/home-client-report.type'

export type THomeTableCardComponent = {
  dataClientReport: TClientReport[]
}

export function HomeTableCardComponent({
  dataClientReport,
}: THomeTableCardComponent) {
  const navigate = useNavigate()
  return (
    <div className="mt-1 md:mt-2">
      <Card className="hidden lg:block bg-white pt-6">
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow className="text-sm uppercase">
                <TableHead className="font-bold">Cliente</TableHead>
                <TableHead className="font-bold">Cidade</TableHead>
                <TableHead className="font-bold">Prev. Compra</TableHead>
                <TableHead className="font-bold">Prm. Compra</TableHead>
                <TableHead className="font-bold">Ult. Compra</TableHead>
                <TableHead className="font-bold">Freq. Compra</TableHead>
                <TableHead className="font-bold">Vr. Medio</TableHead>
                <TableHead className="font-bold">Vr. Medio Prod.</TableHead>
                <TableHead className="font-bold">Vr. Ult. Compra</TableHead>
              </TableRow>
            </TableHeader>

            <TableBody>
              {dataClientReport?.map((item) => (
                <TableRow
                  key={item.identidade}
                  className="text-sm cursor-pointer"
                  onClick={() => navigate(`/cliente/view/${item.identidade}`)}
                >
                  <TableCell>{item.cliente}</TableCell>
                  <TableCell>{item.cidade}</TableCell>
                  <TableCell>
                    {formatDateBy(item.datacompra, 'DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    {formatDateBy(item.primeiracompra, 'DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>
                    {formatDateBy(item.ultimacompra, 'DD/MM/YYYY')}
                  </TableCell>
                  <TableCell>{item.frequencia}</TableCell>
                  <TableCell>
                    {numberFormatter.format(item.valormediocompra)}
                  </TableCell>
                  <TableCell>
                    {numberFormatter.format(item.valormedioproduto)}
                  </TableCell>
                  <TableCell>
                    {numberFormatter.format(item.valorultimacompra)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <div className="block lg:hidden">
        <div className="grid grid-cols-1 gap-1 md:gap-2">
          {dataClientReport?.map((item) => (
            <Card
              className={cn(
                'rounded-lg border bg-card relative text-card-foreground shadow-xs flex-1 card-container',
              )}
              key={item.identidade}
            >
              <CardContent className={cn('p-3 w-full')}>
                <div className="uppercase text-xs">
                  <h1 className="text-sm mb-2 font-bold truncate w-full pr-10">
                    {item.cliente}
                  </h1>

                  <p>{item.cidade}</p>

                  <p>
                    Dt Compra:{' '}
                    <strong>{formatDateBy(item.datacompra, 'DD/MM/YY')}</strong>
                  </p>

                  <p>
                    Freq. Compra: <strong>{item.frequencia}</strong>
                  </p>

                  <p>
                    Dt Ult Compra:{' '}
                    <strong>
                      {formatDateBy(item.ultimacompra, 'DD/MM/YY')}
                    </strong>
                  </p>

                  <p>
                    Vr Ult Compra:{' '}
                    <strong>
                      {numberFormatter.format(item.valorultimacompra)}
                    </strong>
                  </p>
                </div>
              </CardContent>
              <div
                className={cn(
                  ' absolute top-0 right-8 p-3 md:p-3 rounded-r-md h-full ',
                )}
              />
              <div
                onKeyUp={(e) => {
                  if (e.key === 'Enter') {
                    navigate(`/cliente/view/${item.identidade}`)
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  navigate(`/cliente/view/${item.identidade}`)
                }}
                className={cn(
                  ' absolute top-0 right-0  p-2 md:p-2 rounded-r-md h-full  bg-gray-200/30',
                )}
              >
                <ExternalLink className="text-gray-600 ml-1" size={16} />
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}
